import { render, staticRenderFns } from "./CheckoutTemplate.vue?vue&type=template&id=86454328&"
import script from "./CheckoutTemplate.vue?vue&type=script&lang=js&"
export * from "./CheckoutTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports